// ====== Copie code promo (Vanilio Ads) ======
window.vCopy = function(btn){
  var text = btn.getAttribute('data-copy') || 'BLOG10';

  function onDone(){
    var codeEl = btn.querySelector('.v-copy-code');
    var old = codeEl.textContent;
    codeEl.textContent = 'Copié !';
    setTimeout(function(){ codeEl.textContent = old; }, 1400);
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(onDone).catch(function(){
      var ta = document.createElement('textarea');
      ta.value = text; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch(e){}
      document.body.removeChild(ta); onDone();
    });
  } else {
    var ta = document.createElement('textarea');
    ta.value = text; document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch(e){}
    document.body.removeChild(ta); onDone();
  }
};